import { UserDTO } from '@ringo/shared'
import { FC, ReactNode, useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUser } from '../../common/hooks/auth/useUser'

interface ProtectedRouteProps {
    children: ReactNode
    permissionChecker?: (user: UserDTO) => boolean
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ children, permissionChecker }) => {
    const { isAuthenticated, user } = useUser()
    const navigate = useNavigate()

    const hasPermission = useMemo(() => {
        if (!isAuthenticated || !user) {
            return false
        }

        return !permissionChecker || permissionChecker(user)
    }, [user, isAuthenticated, permissionChecker])

    useEffect(() => {
        if (!hasPermission && window.location.pathname !== '/auth/login' && window.location.pathname !== '/') {
            navigate('/auth/login')
        }
    }, [hasPermission, navigate])

    if (!hasPermission) {
        return <div>{user?.verificationStatus}</div>
    }

    return <>{children}</>
}

export default ProtectedRoute
